<template>
  <footer class="bg-[#1c4848] pt-24 pb-12 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-[#ecd79f]/30 to-transparent"></div>
    <div class="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#ecd79f]/5 blur-[100px] rounded-full pointer-events-none"></div>

    <div class="max-w-7xl mx-auto px-6 relative z-10 flex flex-col items-center text-center">
      <div
        class="w-16 h-16 rounded-2xl bg-[#ecd79f] flex items-center justify-center shadow-[0_0_30px_rgba(236,215,159,0.3)] mb-8 overflow-hidden p-2"
      >
        <img :src="logoGreenUrl" alt="Deenly" class="w-full h-full object-contain" />
      </div>

      <h2 class="text-4xl lg:text-5xl font-serif text-white font-semibold tracking-tight mb-6">
        {{ t('home.cta.title') }}
      </h2>
      <p class="text-white/60 font-medium max-w-md mb-10">
        {{ t('home.cta.subtitle') }}
      </p>

      <div class="flex flex-col sm:flex-row gap-4 mb-24">
        <a
          href="https://apps.apple.com/us/app/deenly/id1608171212"
          target="_blank"
          rel="noreferrer"
          class="w-full sm:w-auto cta-appstore rounded-2xl"
        >
          <div class="cta-inner px-8 py-4 rounded-2xl flex items-center justify-center gap-3 text-white">
            <iconify-icon icon="mdi:apple" class="block text-xl leading-none"></iconify-icon>
            <span class="text-sm font-semibold">{{ t('home.download.ios') }}</span>
          </div>
        </a>
      </div>

      <div class="w-full border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-medium text-white/40">
        <p>{{ t('home.footer.copyright') }}</p>
        <div class="flex gap-6">
          <router-link to="/privacy/" class="hover:text-white transition-colors">
            {{ t('home.footer.links.privacy') }}
          </router-link>
          <a href="#" class="hover:text-white transition-colors">
            {{ t('home.footer.links.terms') }}
          </a>
          <a href="#" class="hover:text-white transition-colors">
            {{ t('home.footer.links.contact') }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const logoGreenUrl = new URL('../../assets/deenly_logo_green.svg', import.meta.url).href;
</script>

